<template>
  <b-card>
    <validation-observer ref="simpleRules">
      <b-form>

        <!-- Project Select -->
        <b-form-group
          :label="$t('Project')"
          label-for="mc-project"
        >
          <validation-provider
            #default="{ errors }"
            name="Part"
            rules="required"
          >

            <v-select
              id="vue-select-project"
              v-model="reportRequest.projectId"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionProject"
              :reduce="project => project.id"
              label="projectName"
              :placeholder="$t('Select project...')"
              :state="errors.length > 0 ? false:null"
              @input="projectSelected"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>

        </b-form-group>

        <template v-if="reportRequest.projectId">
          <h6 class="mt-1">
            {{ $t('Periods') }}
          </h6>

          <b-row>
            <!-- Part -->
            <b-col md="3">
              <b-form-group
                :label="$t('Part')"
                label-for="mc-part"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Part"
                  rules="required"
                >
                  <v-select
                    id="vue-select-part"
                    v-model="reportRequest.part"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionPart"
                    :clearable="false"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Start Wave -->
            <b-col md="3">
              <b-form-group
                :label="$t('From')"
                label-for="mc-from"
              >
                <validation-provider
                  #default="{ errors }"
                  name="From"
                  rules="required"
                >
                  <v-select
                    id="vue-select-from-wave"
                    v-model="reportRequest.fromWave"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionPeriod"
                    :placeholder="$t('from...')"
                    :clearable="false"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End Period -->
            <b-col md="3">
              <b-form-group
                :label="$t('To')"
                label-for="mc-to"
              >
                <validation-provider
                  #default="{ errors }"
                  name="To"
                  rules="required"
                >
                  <v-select
                    id="vue-select-to-wave"
                    v-model="reportRequest.toWave"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionPeriod"
                    :placeholder="$t('...to')"
                    :state="errors.length > 0 ? false:null"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <!-- Rolling -->
              <b-form-group
                :label="$t('Rolling')"
                label-for="mc-rolling"
              >
                <v-select
                  id="vue-select-rolling"
                  v-model="reportRequest.rolling"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionRolling"
                  :clearable="false"
                  :placeholder="$t('No rolling')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="d-inline-block mr-1"
            :disabled="inProgress"
            @click="validationForm"
          >
            {{ btnLabel }}
          </b-button>
        </template>

      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    vSelect,
    BCard,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      reportRequest: {
        fromWave: null,
        toWave: null,
        projectId: null,
        rolling: 1,
        part: 1,
      },
      required,
      optionPeriod: [],
      optionRolling: [1, 2, 3, 4, 5],
      optionProject: [],
      optionPart: [],
      optionAndOr: [
        'AND', 'OR',
      ],
      inProgress: false,
      btnLabel: this.$t('OK'),
    }
  },
  async created() {
    this.getProjectOptions()
  },
  methods: {
    projectSelected() {
      this.getPeriods()
      this.getParts()
    },
    getPeriods() {
      useJwt.axiosIns.get(`project/${this.reportRequest.projectId}/wavelist`).then(data => {
        const periodItems = data.data.sort((a, b) => b - a)
        const latestPeriod = periodItems[0]
        this.optionPeriod = periodItems
        this.reportRequest.fromWave = latestPeriod
        this.reportRequest.toWave = latestPeriod
      })
    },
    getParts() {
      useJwt.axiosIns.get(`report/${this.reportRequest.projectId}/parts`).then(data => {
        const partItems = data.data
        const firstPart = partItems[0]
        this.optionPart = partItems
        this.reportRequest.part = firstPart
      })
    },
    getProjectOptions() {
      useJwt.axiosIns.get('project').then(response => {
        this.optionProject = response.data
      })
    },
    openFile(response, filename) {
      const blob = new Blob([`\ufeff${response.data}`], {
        type: 'text/csv; charset=utf-8',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.inProgress = true
          this.btnLabel = this.$t('Please wait...')

          useJwt.axiosIns.get(`report/${this.reportRequest.projectId}/${this.reportRequest.part}/${this.reportRequest.fromWave}/${this.reportRequest.toWave}`)
            .then(response => {
              if (response.data) {
                this.openFile(response, `report_${this.reportRequest.projectId}_${this.reportRequest.part}_${this.reportRequest.fromWave}_${this.reportRequest.toWave}.csv`)
              }

              this.inProgress = false
              this.btnLabel = this.$t('OK')
            })
            .catch(e => {
              console.log(e)
              this.inProgress = false
              this.btnLabel = this.$t('OK')
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';

</style>
